<template>
    <v-card
        v-if="$vuetify.breakpoint.xs && currentRoute"
        class="overflow-hidden rounded-0"
    >
        <v-bottom-navigation
            v-model="bottomNav"
            app
            grow
            hide-on-scroll
            scroll-threshold="200"
            color="primary"
            shift
        >
            <v-btn
                v-for="(link, index) in filteredLinks"
                :key="index"
                :to="{ name: link.link }"
                text
            >
                <v-icon>{{ link.icon }}</v-icon>
                <span>{{ link.title }}</span>
            </v-btn>
        </v-bottom-navigation>
    </v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
    name: 'BottomNav',

    data: () => ({
        bottomNav: 0,
        noBotRoutes: ['login', 'maintenance', 'databaseManagement', 'mfaSetup', 'OfferConfigurator'],
    }),
    computed: {
		...mapState('general', {
			GROUPS: (state) => state.GROUPS,
			ERP_GROUPS: (state) => state.ERP_GROUPS,
			rolesEncoded: (state) => state.rolesEncode,
		}),
        currentRoute() {
            return !this.noBotRoutes.some(r => this.$route?.name?.includes(r));
        },
        rol() {
            return this.$store.state.general.rolesDecode[this.rolEncoded];
        },
        ...mapState('login', {
            fullName: (state) => state.nombre,
            rolEncoded: (state) => state.rol,
        }),
        ...mapGetters('login', {
            hasAdminPermission: 'hasAdminPermission',
            isDistributor: 'isDistributor',
			checkRolePermission: 'checkRolePermission',
			ckeckGroupPermission: 'ckeckGroupPermission',
			hasManagerPermission: 'hasManagerPermission',
			hasSuperAdminPermission: 'hasSuperAdminPermission',
        }),
        color() {
            switch (this.bottomNav) {
                case 0:
                    return 'blue-grey';
                case 1:
                    return 'teal';
                case 2:
                    return 'brown';
                case 3:
                    return 'indigo';
            }
        },
        filteredLinks() {
            // return this.links.filter((link) => this.permissionChecker(link.permission));
			if (!this.links) {
				return [];
			}

			return this.links.filter((item) => {
				return (
					this.checkRolePermission(item.role) &&
					this.ckeckGroupPermission(item.groups)
				);
			});
        },
        links() {
            return [
                {
                    link: 'dashboard',
                    icon: 'mdi-chart-bar',
                    title: 'Dashboard',
                    groups: this.ERP_GROUPS,
                    role: null
                    // permission: [
                    //     'isDistributor',
                    // ],
                },
                {
                    link: 'teletrabajo',
                    icon: 'mdi-database',
                    title: 'Teletrabajo',
                    groups: this.ERP_GROUPS,
                    permission: [
                        'isDistributor',
                    ],
                },
                // {
                //     link: 'gerencia',
                //     icon: 'mdi-car-cruise-control',
                //     title: 'Gerencia',
                //     groups: this.ERP_GROUPS,
                //     role: this.rolesEncoded.Manager,
                //     // permission: [
                //     //     'hasManagerPermission',
                //     //     'isDistributor',
                //     // ],
                // },
                // {
                //     link: 'managementBase',
                //     icon: 'mdi-controller-classic',
                //     title: 'Administración',
				// 	groups: this.ERP_GROUPS,
				// 	role: this.rolesEncoded.Admin,
                //     // permission: [
                //     //     'hasAdminPermission',
                //     //     'isDistributor',
                //     // ],
                // },
                // {
                //     link: 'devicemanagement',
                //     icon: 'mdi-cellphone',
                //     title: 'Dispositivos',
				// 	groups: [this.GROUPS.MASMOVIL],
				// 	role: null,
                //     // permission: [
                //     //     '!hasManagerPermission',
                //     //     'isDistributor',
                //     // ],
                // },
                {
                    link: 'areaPersonal',
                    icon: 'mdi-basket-plus-outline',
                    title: 'Area Personal',
					groups: this.ERP_GROUPS,
					role: null,
                    // permission: [
                    //     'isDistributor',
                    // ],
                },
                // {
                //     link: 'fichaje',
                //     icon: 'mdi-timer-outline',
                //     title: 'Fichaje',
				// 	groups: [this.GROUPS.PUNCH_IN],
				// 	role: null,
                //     // permission: [
                //     //     '!isDistributor',
                //     // ],
                // },
                // {
                //     link: 'documentos',
                //     icon: 'mdi-folder-account-outline',
                //     title: 'Documentos',
				// 	groups: [this.GROUPS.STORAGE],
				// 	role: null,
                //     // permission: [
                //     //     '!isDistributor',
                //     // ],
                // },
                {
                    link: 'vacaciones',
                    icon: 'mdi-beach',
                    title: 'Vacaciones',
					groups: [],
					role: this.rolesEncoded.Comercial,
                    // permission: [
                    //     '!isDistributor',
                    // ],
                },
                {
                    link: 'rrhh',
                    icon: 'mdi-account-group',
                    title: 'RRHH',
					groups: [],
					role: this.rolesEncoded.Admin,
                    // permission: [
                    //     '!isDistributor',
                    //     'hasAdminPermission',
                    // ],
                }
            ]
        },
    },
    methods: {
        permissionChecker(permissions) {
            let hasPermission = true;
            
            permissions.forEach((permission) => {
                let permissiopnString = `this.${permission}`;
                if (permissiopnString.includes('!')) {
                    // find and delete ! character
                    permissiopnString = permissiopnString.replace('!', '');
                    permissiopnString = `!${permissiopnString}`;
                }

                hasPermission = hasPermission && eval(permissiopnString);
            });

            return hasPermission;
        },
    },
};
</script>